__turbopack_context__.v({
  "circle": "vYpNsa_circle",
});
